import { render, staticRenderFns } from "./sales-contact.vue?vue&type=template&id=101fb3a8"
import script from "./sales-contact.vue?vue&type=script&lang=js"
export * from "./sales-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports